// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2xptX","dragIcon":"SortableItem_dragIcon__2uVLW","disabled":"SortableItem_disabled__3bBc7"};